(function () {
  var drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  var sectionId = drawer.getAttribute("data-section-id");
  var busy = false;
  var wasOpen = false;
  var body = document.body;

  function openDrawer() {
    drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    body.classList.add("is-cart-open");
    wasOpen = true;
  }

  function closeDrawer() {
    drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer || !drawer.classList.contains("is-open")) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    body.classList.remove("is-cart-open");
    wasOpen = false;
  }

  function cartUrl(path) {
    return window.Shopify && Shopify.routes ? Shopify.routes.root + path : "/" + path;
  }

  function changeLine(lineKey, quantity) {
    return fetch(cartUrl("cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart update failed");
      return res.json();
    });
  }

  function addVariant(variantId, quantity) {
    return fetch(cartUrl("cart/add.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 }),
    }).then(function (res) {
      if (!res.ok) throw new Error("Add to cart failed");
      return res.json();
    });
  }

  function changeLineSellingPlan(lineKey, quantity, sellingPlan) {
    return fetch(cartUrl("cart/change.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        selling_plan: parseInt(sellingPlan, 10),
      }),
    }).then(function (res) {
      if (!res.ok) throw new Error("Cart update failed");
      return res.json();
    });
  }

  function formatMoney(cents, moneyFormat) {
    var value = Number(cents) || 0;
    var format = moneyFormat || "{{amount}}";

    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(value, format);
    }

    var amount = (value / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(value / 100));

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function refreshDrawer(keepOpen) {
    if (!sectionId) return Promise.resolve();

    var shouldKeepOpen =
      keepOpen !== false &&
      (wasOpen || (drawer && drawer.classList.contains("is-open")));

    return fetch("/?sections=" + encodeURIComponent(sectionId))
      .then(function (res) {
        if (!res.ok) throw new Error("Section render failed");
        return res.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var wrapper = document.createElement("div");
        wrapper.innerHTML = html.trim();
        var next = wrapper.querySelector("[data-cart-drawer]");
        var current = document.querySelector("[data-cart-drawer]");
        if (!next || !current) return;

        current.replaceWith(next);
        drawer = next;
        bindDrawer();

        if (shouldKeepOpen) openDrawer();
      });
  }

  function bindQtyControls() {
    if (!drawer) return;

    drawer.querySelectorAll("[data-cart-drawer-item]").forEach(function (itemEl) {
      var lineKey = itemEl.getAttribute("data-line-key");
      var minusBtn = itemEl.querySelector("[data-cart-drawer-qty-minus]");
      var plusBtn = itemEl.querySelector("[data-cart-drawer-qty-plus]");
      var qtyValue = itemEl.querySelector("[data-cart-drawer-qty-value]");
      var removeBtn = itemEl.querySelector("[data-cart-drawer-remove]");
      var qty = parseInt(qtyValue && qtyValue.textContent, 10) || 1;

      function setBusy(state) {
        busy = state;
        if (minusBtn) minusBtn.disabled = state || qty <= 1;
        if (plusBtn) plusBtn.disabled = state;
        if (removeBtn) removeBtn.disabled = state;
      }

      function applyQty(nextQty) {
        if (busy || !lineKey) return;
        setBusy(true);
        changeLine(lineKey, nextQty)
          .then(function () {
            return refreshDrawer(true);
          })
          .catch(function () {
            window.location.reload();
          })
          .finally(function () {
            setBusy(false);
          });
      }

      if (minusBtn) {
        minusBtn.addEventListener("click", function () {
          if (qty <= 1) return;
          applyQty(qty - 1);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener("click", function () {
          applyQty(qty + 1);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener("click", function () {
          applyQty(0);
        });
      }

      if (minusBtn) minusBtn.disabled = qty <= 1;
    });
  }

  function bindUpsell() {
    if (!drawer) return;
    var btn = drawer.querySelector("[data-cart-drawer-upsell-add]");
    if (!btn) return;

    btn.addEventListener("click", function () {
      if (busy) return;
      var variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;

      busy = true;
      btn.disabled = true;

      addVariant(variantId, 1)
        .then(function () {
          return refreshDrawer(true);
        })
        .catch(function () {
          window.location.reload();
        })
        .finally(function () {
          busy = false;
        });
    });
  }

  function bindSubscribe() {
    if (!drawer) return;
    var root = drawer.querySelector("[data-cart-drawer-subscribe]");
    if (!root) return;

    var plans = Array.from(root.querySelectorAll("[data-cart-plan]"));
    var priceEl = root.querySelector("[data-subscribe-price]");
    var compareEl = root.querySelector("[data-subscribe-compare]");
    var submitBtn = root.querySelector("[data-cart-drawer-subscribe-submit]");
    var moneyFormat = root.getAttribute("data-money-format") || "{{amount}}";
    var radioOn = root.getAttribute("data-radio-on") || "";
    var radioOff = root.getAttribute("data-radio-off") || "";

    function activePlan() {
      return root.querySelector("[data-cart-plan].is-active") || plans[0] || null;
    }

    function setActivePlan(nextPlan) {
      plans.forEach(function (plan) {
        var isActive = plan === nextPlan;
        var icon = plan.querySelector("[data-cart-plan-icon]");
        plan.classList.toggle("is-active", isActive);
        plan.setAttribute("aria-pressed", isActive ? "true" : "false");
        if (icon && radioOn && radioOff) {
          icon.setAttribute("src", isActive ? radioOn : radioOff);
        }
      });

      var cents = parseInt(nextPlan.getAttribute("data-plan-price"), 10);
      if (priceEl && !isNaN(cents)) {
        priceEl.textContent = formatMoney(cents, moneyFormat);
      }
      if (compareEl && !isNaN(cents)) {
        var compareCents = parseInt(compareEl.getAttribute("data-compare-cents"), 10);
        compareEl.hidden = !isNaN(compareCents) && cents >= compareCents;
      }
    }

    plans.forEach(function (plan) {
      plan.addEventListener("click", function () {
        setActivePlan(plan);
      });
    });

    if (submitBtn) {
      submitBtn.addEventListener("click", function () {
        if (busy) return;
        var plan = activePlan();
        if (!plan) return;

        var updates = [];
        try {
          updates = JSON.parse(plan.getAttribute("data-plan-updates") || "[]");
        } catch (error) {
          updates = [];
        }
        if (!updates.length) return;

        busy = true;
        submitBtn.disabled = true;
        plans.forEach(function (item) {
          item.disabled = true;
        });

        updates
          .reduce(function (promise, update) {
            return promise.then(function () {
              return changeLineSellingPlan(update.key, update.quantity, update.selling_plan);
            });
          }, Promise.resolve())
          .then(function () {
            return refreshDrawer(true);
          })
          .catch(function () {
            window.location.reload();
          })
          .finally(function () {
            busy = false;
          });
      });
    }
  }

  function bindAddButtons(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-cart-add]").forEach(function (btn) {
      if (btn.dataset.cartAddBound) return;
      btn.dataset.cartAddBound = "1";

      btn.addEventListener("click", function (event) {
        event.preventDefault();
        if (busy) return;

        var variantId = btn.getAttribute("data-variant-id");
        if (!variantId) return;

        busy = true;
        btn.disabled = true;

        addVariant(variantId, 1)
          .then(function () {
            return refreshDrawer(true);
          })
          .then(function () {
            openDrawer();
          })
          .catch(function () {
            window.location.reload();
          })
          .finally(function () {
            busy = false;
            btn.disabled = false;
          });
      });
    });
  }

  function bindDrawer() {
    drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;

    sectionId = drawer.getAttribute("data-section-id") || sectionId;

    drawer.querySelectorAll("[data-cart-drawer-close]").forEach(function (button) {
      button.addEventListener("click", closeDrawer);
    });

    bindQtyControls();
    bindUpsell();
    bindSubscribe();
    bindAddButtons(drawer);
  }

  document.addEventListener("click", function (event) {
    var openTrigger = event.target.closest("[data-cart-drawer-open]");
    if (!openTrigger) return;
    if (!document.querySelector("[data-cart-drawer]")) return;
    event.preventDefault();
    openDrawer();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeDrawer();
  });

  document.addEventListener("submit", function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (!document.querySelector("[data-cart-drawer]")) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    event.preventDefault();
    if (busy) return;

    busy = true;
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    addVariant(idInput.value, 1)
      .then(function () {
        return refreshDrawer(true);
      })
      .then(function () {
        openDrawer();
      })
      .catch(function () {
        window.location.reload();
      })
      .finally(function () {
        busy = false;
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  bindDrawer();
  bindAddButtons(document);

  window.CpCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: function () {
      return refreshDrawer(true);
    },
    openAfterAdd: function () {
      return refreshDrawer(true).then(function () {
        openDrawer();
      });
    },
    isEnabled: function () {
      return !!document.querySelector("[data-cart-drawer]");
    },
  };
})();
